const rules = {
	user: {
		static: [
			"drawer-service-items:view", // ✅ Solo puede ver elementos de servicio
			// ❌ NO tiene acceso a elementos administrativos
		],
	},

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"drawer-service-items:view", // ✅ Admin también puede ver elementos de servicio
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"update-version",
			"users-page:startAudit"
		],
	},
};

export default rules;
